import router from "./router";
import getPageTitle from "@/utils/get-page-title";
import Cookies from 'js-cookie';
import { hasModulePermissions } from "@api/user";

const MODULE_MAP = {
  DASHBOARD_LIST: 10,
  ACTIVE_LIST: 20,
  SUBJECT_LIST: 30,
  DISCUSS_LIST: 40,
  COOPERATE_LIST: 50,
  STATIONED_LIST: 60,
  JOURNAL_LIST: 70,
  POINTMALL_LIST: 80,
  ABOUT_LIST: 90,
};

function getTwsId() {
  try {
    const siteData = Cookies.get('siteData');
    if (siteData) {
      const obj = JSON.parse(siteData);
      return obj.tws_id || 0;
    }
  } catch (_) {}
  return 0;
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.length == 0) {
    next({ path: '/' })
  }

  document.title = getPageTitle(to.meta.title);

  const key = to.meta && to.meta.personname ? to.meta.personname : '';
  const moduleId = MODULE_MAP[key];
  if (moduleId) {
    try {
      const tws_id = getTwsId();
      const res = await hasModulePermissions({ module_ids: [moduleId], tws_id });
      const allow = res && res.status === 200 && res.data && res.data.list && res.data.list[moduleId] === 1;
      if (!allow) {
        next({ path: '/' });
        return;
      }
    } catch (e) {
      next({ path: '/' });
      return;
    }
  }

  next();
});

router.afterEach(() => { });
